import {
  EDIT_SETTINGS,
  EDIT_SETTINGS_FAILURE,
  EDIT_SETTINGS_SUCCESS,
  GET_SETTINGS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
} from "./actionTypes";

export const getSettings = (payload) => {
  return {
    type: GET_SETTINGS,
    payload,
  };
};

export const getSettingsSuccess = (payload) => {
  return {
    type: GET_SETTINGS_SUCCESS,
    payload,
  };
};

export const getSettingsFailure = (payload) => {
  return {
    type: GET_SETTINGS_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const editSettings = (payload) => {
  return {
    type: EDIT_SETTINGS,
    payload,
  };
};

export const editSettingsSuccess = (payload) => {
  return {
    type: EDIT_SETTINGS_SUCCESS,
    payload,
  };
};

export const editSettingsFailure = (payload) => {
  return {
    type: EDIT_SETTINGS_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
